import React from "react";

type ContractsPageContextValue = {
	triggerRefresh: () => void;
};

export default React.createContext<ContractsPageContextValue>({
	triggerRefresh: () => {},
});
